<template>
  <footer class="footer pt-40">
    <div class="container">
      <div class="row y-gap-30 pb-60">
        <div class="col-lg-4 col-md-6 d-flex flex-column justify-between">
          <div>
            <div class="footer-header__logo">
              <img src="../../assets/images/home/logo-light.svg" alt="logo" />
            </div>

            <div class="mt-10 pr-20">
              <div>
                <p>
                  {{ $t('footer.description') }}
                </p>
              </div>
            </div>
          </div>

          <div class="mt-50 social-links">
            <div class="d-flex align-items-center gap-1">
              <a href="https://www.facebook.com/Ali.Katary.15" aria-label="Planning force page link on facebook" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                  <path
                    d="M8.55078 25.2904C8.55174 29.3261 9.99211 33.2291 12.613 36.298C15.2339 39.3668 18.8634 41.4002 22.8493 42.0327V30.1882H18.5497V25.2904H22.8544V21.562C22.7593 20.6893 22.8576 19.8065 23.1422 18.9761C23.4268 18.1457 23.8907 17.3882 24.501 16.7573C25.1114 16.1264 25.8531 15.6376 26.6737 15.3257C27.4942 15.0138 28.3733 14.8864 29.2486 14.9525C30.5197 14.9728 31.7907 15.0864 33.0448 15.2914V19.4588H30.9027C30.5386 19.4111 30.1684 19.4459 29.8196 19.5605C29.4707 19.6751 29.1521 19.8666 28.8872 20.1209C28.6224 20.3752 28.418 20.6858 28.2893 21.0296C28.1606 21.3735 28.1108 21.742 28.1436 22.1077V25.2904H32.8397L32.089 30.1899H28.1436V42.0327C31.3427 41.5271 34.3298 40.1155 36.7515 37.9649C39.1731 35.8144 40.9278 33.0149 41.8079 29.8981C42.6879 26.7812 42.6564 23.4774 41.7171 20.3779C40.7778 17.2784 38.97 14.5129 36.5078 12.4089C34.0456 10.3049 31.032 8.95053 27.8239 8.50606C24.6159 8.06159 21.3476 8.54568 18.4061 9.901C15.4646 11.2563 12.9731 13.4261 11.2264 16.1535C9.47983 18.8809 8.5513 22.0517 8.55078 25.2904Z"
                    fill="white" />
                </svg>
              </a>
              
              <a href="https://www.linkedin.com/company/planning-force/?viewAsMember=true" aria-label="Planning force account link on linkedin" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                  <path
                    d="M37.0914 12.7109H15.4298C14.3939 12.7109 13.5532 13.5318 13.5532 14.5427V36.2978C13.5532 37.31 14.3939 38.132 15.4298 38.132H37.0914C38.128 38.132 38.9743 37.31 38.9743 36.2978V14.5427C38.9743 13.5318 38.128 12.7109 37.0914 12.7109ZM21.0927 34.3732H17.3205V22.2421H21.0927V34.3732ZM19.2066 20.5833C18.9195 20.5833 18.6351 20.5268 18.3699 20.4168C18.1047 20.3069 17.8637 20.1458 17.6607 19.9427C17.4577 19.7396 17.2968 19.4985 17.187 19.2332C17.0773 18.9679 17.0209 18.6835 17.0211 18.3964C17.0211 17.8168 17.2513 17.261 17.6611 16.8512C18.071 16.4413 18.6268 16.2111 19.2064 16.2111C19.786 16.2111 20.3418 16.4413 20.7517 16.8512C21.1615 17.261 21.3917 17.8168 21.3917 18.3964C21.3917 18.9761 21.1616 19.5321 20.7518 19.9422C20.3421 20.3523 19.7863 20.5829 19.2066 20.5833ZM35.2141 34.3732H31.4479V28.4741C31.4479 27.0668 31.4203 25.2573 29.488 25.2573C27.5256 25.2573 27.2266 26.79 27.2266 28.3721V34.3736H23.4575V22.2421H27.0748V23.8987H27.1263C27.6298 22.9454 28.8599 21.9395 30.6944 21.9395C34.5097 21.9395 35.2144 24.4512 35.2144 27.7189L35.2141 34.3732Z"
                    fill="white" />
                </svg>
              </a>
              <!-- <a href="#" aria-label="Planning force account link on twitter">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                  <path
                    d="M43.0944 15.2938C42.1656 16.6776 40.9902 17.9098 39.6254 18.8956C39.6443 19.1799 39.6443 19.4832 39.6443 19.7865C39.6443 28.9806 32.6493 39.5774 19.8724 39.5774C15.9483 39.5774 12.2897 38.421 9.19971 36.4495C9.74945 36.5064 10.2992 36.5443 10.8679 36.5443C14.1285 36.5443 17.1236 35.4259 19.4932 33.5681C18.0437 33.5381 16.6397 33.0562 15.4774 32.1895C14.3151 31.3229 13.4524 30.1148 13.01 28.7341C13.4271 28.81 13.8631 28.8668 14.318 28.8668C14.9436 28.8668 15.5692 28.772 16.1379 28.6204C14.5656 28.2976 13.1527 27.4426 12.1375 26.1994C11.1222 24.9562 10.5667 23.401 10.5646 21.7959V21.7201C11.5124 22.232 12.574 22.5542 13.7114 22.5921C12.7594 21.9535 11.9795 21.0902 11.4405 20.0784C10.9016 19.0667 10.6203 17.9377 10.6215 16.7914C10.6215 15.5213 10.9627 14.327 11.5693 13.3033C15.0005 17.5117 20.1188 20.2794 25.9006 20.5638C25.7869 20.0519 25.7111 19.5211 25.7111 18.9714C25.7161 17.1295 26.4513 15.3648 27.7555 14.0642C29.0596 12.7636 30.8263 12.0332 32.6682 12.0332C34.6776 12.0332 36.4785 12.8673 37.7486 14.2322C39.322 13.9099 40.8196 13.3412 42.1656 12.545C41.6348 14.1564 40.5353 15.5213 39.0946 16.3743C40.4757 16.2233 41.8251 15.8588 43.0944 15.2938Z"
                    fill="white" />
                </svg>
              </a> -->
              <a href="https://www.youtube.com/@alikatary" aria-label="Planning force channel on youtube" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                  <path
                    d="M42.2062 17.2875C42.0133 16.5718 41.6363 15.9191 41.1128 15.3944C40.5893 14.8697 39.9374 14.4913 39.2222 14.2967C36.5701 13.5685 25.9601 13.5567 25.9601 13.5567C25.9601 13.5567 15.3517 13.5448 12.698 14.2408C11.9832 14.4443 11.3327 14.8281 10.8089 15.3554C10.2852 15.8827 9.90581 16.5358 9.70719 17.252C9.00775 19.904 9.00098 25.4047 9.00098 25.4047C9.00098 25.4047 8.9942 30.9324 9.68856 33.5573C10.0781 35.0087 11.2212 36.1552 12.6743 36.5464C15.3534 37.2747 25.9347 37.2865 25.9347 37.2865C25.9347 37.2865 36.5447 37.2984 39.1968 36.604C39.9123 36.4098 40.5647 36.0323 41.0896 35.5086C41.6144 34.985 41.9935 34.3334 42.1893 33.6183C42.8904 30.9679 42.8955 25.469 42.8955 25.469C42.8955 25.469 42.9293 19.9396 42.2062 17.2875ZM22.5662 30.5005L22.5747 20.3393L31.393 25.4284L22.5662 30.5005Z"
                    fill="white" />
                </svg>
              </a>
              <!-- <a href="#" aria-label="Planning force account on instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                  <path
                    d="M42.8295 18.4271C42.8105 17.0016 42.5437 15.5902 42.0409 14.2561C41.6049 13.1309 40.9389 12.1089 40.0856 11.2556C39.2323 10.4023 38.2103 9.73631 37.085 9.3003C35.7681 8.80595 34.3769 8.53865 32.9705 8.50977C31.1598 8.42884 30.5858 8.40625 25.9894 8.40625C21.3931 8.40625 20.804 8.40625 19.0065 8.50977C17.6007 8.53886 16.2102 8.80616 14.8938 9.3003C13.7684 9.73601 12.7463 10.4018 11.8929 11.2552C11.0395 12.1086 10.3737 13.1307 9.93799 14.2561C9.44265 15.5721 9.17593 16.963 9.14935 18.3688C9.06841 20.1813 9.04395 20.7554 9.04395 25.3517C9.04395 29.9481 9.04395 30.5353 9.14935 32.3347C9.17758 33.7426 9.44297 35.1317 9.93799 36.4511C10.3744 37.5762 11.0408 38.5979 11.8944 39.4509C12.7481 40.3039 13.7703 40.9695 14.8957 41.4051C16.2084 41.9193 17.5993 42.2057 19.0083 42.252C20.8209 42.333 21.395 42.3574 25.9913 42.3574C30.5877 42.3574 31.1768 42.3574 32.9743 42.252C34.3806 42.2244 35.7719 41.9577 37.0888 41.4634C38.2138 41.0269 39.2355 40.3608 40.0887 39.5075C40.942 38.6542 41.6081 37.6325 42.0446 36.5076C42.5397 35.19 42.805 33.801 42.8333 32.3912C42.9142 30.5805 42.9387 30.0064 42.9387 25.4082C42.9349 20.8119 42.9349 20.2284 42.8295 18.4271ZM25.9781 34.0438C21.171 34.0438 17.2767 30.1495 17.2767 25.3423C17.2767 20.5352 21.171 16.6409 25.9781 16.6409C28.2859 16.6409 30.4991 17.5576 32.131 19.1895C33.7628 20.8213 34.6796 23.0346 34.6796 25.3423C34.6796 27.6501 33.7628 29.8633 32.131 31.4952C30.4991 33.127 28.2859 34.0438 25.9781 34.0438ZM35.0259 18.3481C34.7594 18.3483 34.4954 18.296 34.2491 18.1941C34.0028 18.0922 33.7791 17.9428 33.5906 17.7543C33.4022 17.5659 33.2527 17.3421 33.1508 17.0958C33.0489 16.8495 32.9966 16.5856 32.9969 16.319C32.9969 16.0527 33.0493 15.789 33.1513 15.5429C33.2532 15.2969 33.4026 15.0733 33.5909 14.885C33.7792 14.6966 34.0028 14.5473 34.2488 14.4453C34.4949 14.3434 34.7586 14.291 35.025 14.291C35.2913 14.291 35.555 14.3434 35.8011 14.4453C36.0471 14.5473 36.2707 14.6966 36.459 14.885C36.6473 15.0733 36.7967 15.2969 36.8987 15.5429C37.0006 15.789 37.053 16.0527 37.053 16.319C37.053 17.4408 36.1458 18.3481 35.0259 18.3481Z"
                    fill="white" />
                  <path
                    d="M25.9775 30.994C29.0991 30.994 31.6297 28.4634 31.6297 25.3417C31.6297 22.2201 29.0991 19.6895 25.9775 19.6895C22.8558 19.6895 20.3252 22.2201 20.3252 25.3417C20.3252 28.4634 22.8558 30.994 25.9775 30.994Z"
                    fill="white" />
                </svg>
              </a> -->
            </div>
          </div>
        </div>

        <div class="col-lg-2 col-md-6">
          <div class="text-24 fw-700 text-light-7 uppercase mb-30">
            {{ $t('footer.quick_links') }}
          </div>
          <div class="d-flex y-gap-10 flex-column">
            <router-link to="/" class="capitalize exact">{{ $t('navigation.home') }}</router-link>
            <router-link to="/about" class="capitalize exact">{{ $t('navigation.about') }}</router-link>
            <router-link to="/courses" class="capitalize exact">{{ $t('navigation.courses') }}</router-link>
            <!-- <router-link to="/events" class="capitalize exact">{{ $t('navigation.events') }}</router-link> -->
            <router-link to="/blogs" class="capitalize exact">{{$t('navigation.blogs')}}</router-link>
            <router-link to="/contact" class="capitalize exact">{{ $t('navigation.contact') }}</router-link>
            <router-link to="/certificate" class="capitalize exact">{{ $t('navigation.certificate') }}</router-link>
          </div>

        </div>

        <div class="col-lg-3 col-md-6">
          <div class="text-24 fw-700 text-light-7 uppercase mb-30">
            {{ $t('footer.categories') }}
          </div>
          <div class="row justify-between y-gap-20">
            <div class="col-lg-auto col-md-6">
              <div class="d-flex y-gap-10 flex-column">
                <span class="category-name" @click="goToCourses(category.value)" v-for="category , i in displayedCategories" :key="i">
                  {{ category.label }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!----Location------------>
        <div class="col-lg-3 col-md-6">
          <div class="text-24 fw-700 text-light-7 uppercase mb-30">
            {{ $t('footer.contact_us') }}
          </div>
          <div class="d-flex flex-column mb-20" style="gap: 20px">
            <a href="terms.html">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M18.1992 3.90003C16.2992 2.20003 13.7992 1.30002 11.1992 1.60003C7.19922 1.90003 3.89922 4.80003 3.19922 8.50003C2.69922 10.9 3.19922 13.3 4.69922 15.3L9.79922 22.4C10.1992 23.1 11.0992 23.5 11.9992 23.5C12.8992 23.5 13.7992 23.1 14.2992 22.3L19.3992 15.2C20.4992 13.7 20.9992 12 20.9992 10.2C20.9992 7.80003 19.9992 5.50003 18.1992 3.90003Z"
                    fill="#94AD04" />
                  <path
                    d="M11.9996 13.6008C13.8773 13.6008 15.3996 12.0786 15.3996 10.2008C15.3996 8.32301 13.8773 6.80078 11.9996 6.80078C10.1218 6.80078 8.59961 8.32301 8.59961 10.2008C8.59961 12.0786 10.1218 13.6008 11.9996 13.6008Z"
                    fill="#D9D9D9" />
                </svg>
              </span>
              <span>{{ $t('footer.address') }}</span>
            </a>
            <a href="terms.html">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M5.00102 10.3608C6.91742 14.5346 10.3274 17.8531 14.5669 19.6521L15.2465 19.9549C16.8014 20.6477 18.6291 20.1214 19.5774 18.7079L20.4655 17.3842C20.7543 16.9538 20.6664 16.3741 20.263 16.0487L17.2511 13.6189C16.8088 13.262 16.1583 13.3452 15.8198 13.8018L14.8881 15.0591C12.4973 13.8797 10.5562 11.9387 9.37692 9.54792L10.6341 8.6162C11.0908 8.27778 11.1739 7.62726 10.817 7.18488L8.3872 4.17294C8.06185 3.76966 7.48235 3.68169 7.05198 3.97026L5.71914 4.86396C4.2968 5.81766 3.77342 7.66051 4.48215 9.21946L5.00024 10.3591L5.00102 10.3608Z"
                    fill="#94AD04" />
                </svg>
              </span>
              <span> +201027857863</span>
            </a>
            <a href="terms.html">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                  <path
                    d="M7.28934 5.40749C10.424 5.13501 13.5764 5.135 16.711 5.40749L18.2213 5.53877C19.2266 5.62617 20.0877 6.22584 20.5339 7.08362C20.5909 7.19335 20.5481 7.32621 20.443 7.39132L14.177 11.2703C12.8332 12.1022 11.1386 12.1196 9.77788 11.3156L3.47005 7.58821C3.36814 7.52799 3.32136 7.40403 3.36729 7.29493C3.77545 6.32536 4.69308 5.63318 5.77911 5.53878L7.28934 5.40749Z"
                    fill="#94AD04" />
                  <path
                    d="M3.3623 9.26673C3.20633 9.17457 3.00733 9.27375 2.98915 9.45399C2.73542 11.9696 2.79683 14.509 3.17338 17.0131C3.3719 18.3332 4.44931 19.3453 5.77925 19.4609L7.28948 19.5922C10.4241 19.8647 13.5765 19.8647 16.7111 19.5922L18.2214 19.4609C19.5513 19.3453 20.6287 18.3332 20.8272 17.0131C21.2148 14.4361 21.2685 11.8215 20.9885 9.23413C20.9688 9.05261 20.7665 8.95526 20.6112 9.05136L14.9667 12.5456C13.1485 13.6711 10.8559 13.6947 9.01492 12.6069L3.3623 9.26673Z"
                    fill="#94AD04" />
                </svg>
              </span>
              <span> info@planning-force.com </span>
            </a>
          </div>
          <!--- App Dowload links--
          <div class="app-download">
            <div>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M21.4002 12.9008L16.9002 15.2008L13.7002 12.0008L16.9002 8.80078L21.4002 11.0008C22.2002 11.4008 22.2002 12.6008 21.4002 12.9008Z"
                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M16.9 8.79972L13.7 11.9997L4.1 21.5997L3.5 21.8997C2.8 22.2997 2 21.6997 2 20.8997V3.09972C2 2.29972 2.8 1.79972 3.5 2.09972L16.9 8.79972Z"
                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M13.6996 12.0004L4.09961 21.6004L16.8996 15.2004L13.6996 12.0004ZM13.6996 12.0004L4.09961 2.40039"
                    stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
              <span class="fw-600"> Google Play </span>
            </div>

            <div>
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M19.185 19.16C19.775 18.26 19.995 17.8 20.445 16.79C17.125 15.53 16.595 10.8 19.875 8.99C18.875 7.73 17.465 7 16.135 7C15.175 7 14.515 7.25 13.925 7.48C13.425 7.67 12.975 7.84 12.415 7.84C11.815 7.84 11.285 7.65 10.725 7.45C10.115 7.23 9.47503 7 8.67503 7C7.18503 7 5.59503 7.91 4.58503 9.47C3.16503 11.67 3.41503 15.79 5.70503 19.31C6.52503 20.57 7.62503 21.98 9.05503 22C9.65503 22.01 10.045 21.83 10.475 21.64C10.965 21.42 11.495 21.18 12.425 21.18C13.355 21.17 13.875 21.42 14.365 21.64C14.785 21.83 15.165 22.01 15.755 22C17.205 21.98 18.365 20.42 19.185 19.16ZM15.925 2C16.085 3.1 15.635 4.19 15.045 4.95C14.415 5.77 13.315 6.41 12.255 6.37C12.065 5.31 12.555 4.22 13.155 3.49C13.825 2.69 14.955 2.07 15.925 2Z"
                    fill="white" />
                </svg>
              </span>
              <span class="fw-600"> App Store </span>
            </div>
          </div>
          ---------------->

          <!--- Payment methods-->
          <div class="payment-methods d-flex align-items-center gap-3 mt-30">
            <div>
              <img src="../../assets/images/home/Pay.svg" class="img-fluid" alt="image" />
            </div>
            <div>
              <img src="../../assets/images/home/Mada_Logo.svg" alt="image" class="img-fluid" />
            </div>
            <div>
              <img src="../../assets/images/home/visa.svg" class="img-fluid" alt="image" />
            </div>
            <div>
              <img src="../../assets/images/home/master-card.svg" alt="image" class="img-fluid" />
            </div>
            <div>
              <img src="../../assets/images/home/paypal.svg" alt="image" class="img-fluid" />
            </div>
          </div>
          <!------------------->
        </div>
      </div>

      <div class="py-30 border-top-light">
        <div class="row justify-between items-center y-gap-20">
          <div class="col-auto">
            <div class="footer-footer__copyright d-flex text-light-7 items-center h-100">
              {{ $t('copyright') }} <span class="d-inline-block px-2">|</span> {{ $t('copyright2') }}
            </div>
          </div>

          <div class="col-auto">
            <div class="d-flex x-gap-20 y-gap-20 items-center flex-wrap">
              <div>
                <div class="d-flex x-gap-15">
                  <router-link to="/faq" class="text-light-7 exact">{{ $t('footer.faqs') }}</router-link>
                  <router-link to="/terms" class="text-light-7 exact">{{ $t('footer.terms_services') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import store from '@/store';

export default {
  data(){
    return{
      selectedCategories: [],
    }
  },
  computed: {
    categories() {
      return this.$store.getters.categories
    },
    displayedCategories() {
      return this.categories.length > 6 ? this.categories.slice(0, 6) : this.categories;
    }
  },
  methods:{
    goToCourses(val){
      store.commit('setSelectedCategories', [val]);
      console.log(this.categories, this.selectedCategories);
      this.$router.push('/courses')
    }
  },
  mounted() {
   // store.dispatch("categoriesList");
   // this.selectedCategories = store.getters.selectedCategories;
  }
}
</script>